import React from "react";
import GridLines from "@/components/site/GridLines";

/**
 * RP Selvasundaram testimonial.
 * The green container is a skewed quadrilateral with a large curved
 * bottom-right finish (traced from the Figma frames), and the portrait is
 * masked to the matching shear angle. Desktop and mobile use separate
 * geometry because the Figma frames differ.
 */
export default function Founder() {
  return (
    <section className="rf-founder" data-testid="founder">
      <GridLines />
      <div className="rf-wrap">
        <div className="rf-founder__block">
          {/* desktop shape : local box 880 x 340 */}
          <svg
            className="rf-founder__shape rf-founder__shape--d"
            viewBox="0 0 880 340"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <path
              d="M203 0 L880 0 L847 258 C847 305 800 340 723 340 L0 340 Z"
              fill="#00A94F"
            />
          </svg>

          {/* mobile shape : local box 393 x 410 */}
          <svg
            className="rf-founder__shape rf-founder__shape--m"
            viewBox="0 0 393 410"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <path
              d="M31 0 L393 0 L393 172 C393 300 348 410 268 410 L0 410 L0 124 Z"
              fill="#00A94F"
            />
          </svg>

          <picture className="rf-founder__photo">
            <source media="(max-width: 1023px)" srcSet="/assets/m-founder.png" />
            <img src="/assets/d-founder.png" alt="RP Selvasundaram" />
          </picture>

          <div className="rf-founder__id">
            <p className="rf-founder__name">RP Selvasundaram</p>
            <p className="rf-founder__role">CMD, Renaatus Procon Group</p>
          </div>

          <blockquote className="rf-founder__quote">
            Renaflex is the newest offering from Renacon, built with passion for innovation and
            sustainable construction. The future is for those who dare to dream and find the courage
            to pursue their dreams.
          </blockquote>
        </div>
      </div>
    </section>
  );
}
